var _rect, _rect2, _text, _text2, _text3, _text4, _text5, _text6, _rect3, _text7, _text8, _text9, _rect4, _text0, _text1, _text10, _rect5, _text11, _text12, _text13, _rect6, _text14, _text15, _text16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiraSeverityPriorityMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 720,
    viewBox: "0 0 1200 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 36,
    fill: "#FFFDF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 46,
    width: 1084,
    height: 628,
    rx: 28,
    fill: "white",
    stroke: "#E6E0D3",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 110,
    fill: "#13213F",
    fontFamily: "Arial, sans-serif",
    fontSize: 38,
    fontWeight: 700
  }, "Severity vs Priority Matrix")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 149,
    fill: "#56657A",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Simple visual for interview answers and defect triage discussions")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 205,
    fill: "#173E9F",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "Priority")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 535,
    y: 244,
    fill: "#6B7280",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, "Low to High urgency")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-90 164 410)",
    x: 164,
    y: 410,
    fill: "#C7630A",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "Severity")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-90 198 428)",
    x: 198,
    y: 428,
    fill: "#6B7280",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, "Low to High impact")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 260,
    width: 360,
    height: 160,
    rx: 24,
    fill: "#F5F7FB",
    stroke: "#CFDAEA",
    strokeWidth: 3
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 315,
    fill: "#173E9F",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "Low Severity + Low Priority")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 355,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Footer spelling mistake")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 388,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Minor alignment issue")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 260,
    width: 360,
    height: 160,
    rx: 24,
    fill: "#EEF5FF",
    stroke: "#B7CBEA",
    strokeWidth: 3
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 315,
    fill: "#173E9F",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "Low Severity + High Priority")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 355,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Wrong company logo before launch")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 388,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Brand image impact")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 450,
    width: 360,
    height: 160,
    rx: 24,
    fill: "#FFF4EA",
    stroke: "#F1C78F",
    strokeWidth: 3
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 505,
    fill: "#C7630A",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "High Severity + Low Priority")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 545,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Crash on unsupported browser")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 578,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Technically serious but low business urgency")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 450,
    width: 360,
    height: 160,
    rx: 24,
    fill: "#FFF0EE",
    stroke: "#E9B6B0",
    strokeWidth: 3
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 505,
    fill: "#B42318",
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "High Severity + High Priority")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 545,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Payment deducted but order not placed")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 578,
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 21
  }, "Business loss + user trust issue")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraSeverityPriorityMatrix);
export default __webpack_public_path__ + "static/media/jira-severity-priority-matrix.970b8ad13c02bb6854999d4ed7aaa2be.svg";
export { ForwardRef as ReactComponent };